import { render, staticRenderFns } from "./ConfirmacoesTab.vue?vue&type=template&id=3d7e19d1"
import script from "./ConfirmacoesTab.vue?vue&type=script&lang=js"
export * from "./ConfirmacoesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports